import * as React from 'react';
import * as styles from './styles.css';

export const LabelsBox: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['labels']}>{children}</div>;
};
